/** Source attribution for a page-level error. */
export const PageErrorSource = {
    APPLICATION_SETTINGS: "application-settings",
};
